import { useEffect, useRef } from 'react';
import { useNavigate as useRouterNavigate } from 'react-router';

import { isFirstEntry, seedParent } from '@/lib/bookNavigation';
import { useNavigate } from '@/lib/navigation';

/**
 * Replaces this entry with a section's page (`rest` is the search and hash
 * to keep). When this is the tab's first entry the document is placed
 * behind the section (§3.3), as `seedHistory` does for a cold section URL.
 */
export function ToSection({ docId, sectionId, rest = '' }: { docId: string; sectionId: string; rest?: string }) {
  const routerNavigate = useRouterNavigate();
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const to = `/d/${docId}/s/${sectionId}${rest}`;
    if (isFirstEntry()) seedParent((path, options) => void routerNavigate(path, options), `/d/${docId}`, sectionId, to);
    else navigate(to, { replace: true });
  }, [docId, sectionId, rest, navigate, routerNavigate]);
  return null;
}
